var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.16667 0C1.41777 0 0 1.44793 0 3.23404V28.2979C0 30.084 1.41776 31.5319 3.16667 31.5319H9.81101L15.2292 25.5728C17.265 23.3337 20.735 23.3337 22.7708 25.5728L28.189 31.5319H34.8333C36.5822 31.5319 38 30.084 38 28.2979V3.23404C38 1.44793 36.5822 0 34.8333 0H3.16667ZM15.952 27.608C17.535 25.6568 20.465 25.6568 22.048 27.608L28.3302 35.3513C29.1854 36.4053 28.4514 38 27.111 38H10.889C9.54864 38 8.81461 36.4053 9.66976 35.3513L15.952 27.608ZM19.8833 9.57791C19.8833 8.9573 20.2302 8.70101 20.6556 9.05262L24.6185 12.3251C25.0438 12.6767 25.0438 13.2507 24.6185 13.6002L20.6866 16.8367C20.2592 17.1883 19.8833 16.8324 19.8833 16.3114V14.566H19.2865C17.5663 14.566 14.19 15.3286 13.3867 16.7985C13.2277 17.0675 13.0625 17.0082 13.0625 16.7985C13.0976 14.1784 17.3268 11.2321 19.8131 11.2321H19.8833V9.57791Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoard);
export default __webpack_public_path__ + "static/media/Board.e3165049771ad2e5bd34cc2d7cd49086.svg";
export { ForwardRef as ReactComponent };